import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { FiltroListaDistribuzioneVO } from "@app/shared/vo/gescor/filtro-lista-distribuzioneVO";
import { FiltroListaDistribuzioneDTO } from "@app/shared/dto/anagrafe/filtro-lista-distribuzioneDTO";

@Injectable({
    providedIn: "root"
  })
export class MapperFiltroListaDistribuzione implements MapperInterface<FiltroListaDistribuzioneDTO, FiltroListaDistribuzioneVO> {
    convertVoToDto(filtroListaDistribuzioneVO: FiltroListaDistribuzioneVO): FiltroListaDistribuzioneDTO {
        console.log("MapperFiltroListaDistribuzione convertVoToDto ");
        const filtroListaDistribuzioneDTO = new FiltroListaDistribuzioneDTO();
        filtroListaDistribuzioneDTO.descrizione = filtroListaDistribuzioneVO.descrizione;
        filtroListaDistribuzioneDTO.nome = filtroListaDistribuzioneVO.nome;
        filtroListaDistribuzioneDTO.nomeSettore = new Array<string>();
        filtroListaDistribuzioneDTO.nomeSettore = filtroListaDistribuzioneVO.nomeSettore;
        return filtroListaDistribuzioneDTO || new FiltroListaDistribuzioneDTO();
    }

    convertDtoToVo(filtroListaDistribuzioneDTO: FiltroListaDistribuzioneDTO): FiltroListaDistribuzioneVO {
        throw new Error("Method not implemented.");
    }

    convertListVoToDto(filtroListaDistribuzioneVOList: FiltroListaDistribuzioneVO[]): FiltroListaDistribuzioneDTO[] {
        throw new Error("Method not implemented.");
    }

    convertListDtoToVo(filtroListaDistribuzioneDTOList: FiltroListaDistribuzioneDTO[]): FiltroListaDistribuzioneVO[] {
        throw new Error("Method not implemented.");
    }

}